import React from 'react';
import { Challenge3dsWrapper, Challenge3dsModalBackdrop, Challenge3dsContent } from './style';

const PagarmeChallenge3dsModal = () => {
  return (
    <Challenge3dsWrapper id='challenge3dsWrapper' className='challenge3dsWrapper'>
      <Challenge3dsModalBackdrop>
        <Challenge3dsContent>
          <div id='tdsMethodContainer' style={{ display: 'none' }}></div>
          <div id='challengeContainer'></div>
        </Challenge3dsContent>
      </Challenge3dsModalBackdrop>
    </Challenge3dsWrapper>
  );
};

export default PagarmeChallenge3dsModal;
